import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from "react-select";

const AddProductModal = (props) => {
    const {onChangeProduct, selectFileChangeProduct,dummy, onplanchangeProduct, Plans, customStyles, preview_file__Product, AddProductAcc} = props

    const [showModel, setShowModel] = useState(true)

  return (
    <div className='modals'>
            <Modal
                onHide={() => { props.onDismiss() }}
                show={showModel}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header closeButton onClick={() => props.onDismiss()}>
                    <Modal.Title>Add / Update Product</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div className="newthememodal">
                        <div container>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-flex ">
                              <span className="labelspan me-2">Name of Product</span>{" "}
                              <input
                                type="text"
                                id="ProductName"
                                className="edit_inputs_align"
                                placeholder="Enter ProductName*"
                                onChange={(e) => onChangeProduct(e)}
                                name="wallet address"
                              />
                            </div>
                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-flex ">
                              <div>
                                {" "}
                                <span className="labelspan me-2">Display Name</span>
                              </div>
                              <input
                                type="text"
                                id="DisplayName"
                                className="edit_inputs_align"
                                placeholder="Enter DisplayName*"
                                onChange={(e) => onChangeProduct(e)}
                                name="wallet address"
                              />
                            </div>
                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-flex ">
                              <div>
                                <span className="labelspan me-2">Description</span>{" "}
                              </div>
                              <textarea
                                className="edit_inputs_align"
                                id="ProductDiscription"
                                onChange={(e) => onChangeProduct(e)}
                              ></textarea>
                            </div>
                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-flex ">
                              <div>
                                {" "}
                                <span className="labelspan me-2">Currency</span>
                              </div>
                              <input
                                type="text"
                                id="ProductCurrency"
                                className="edit_inputs_align"
                                placeholder="Currency*"
                                name="wallet address"
                                onChange={(e) => onChangeProduct(e)}
                              />

                              {/* <Select
                              onChange={(e) => onplanchangeProduct(e)}
                              options={Plans}
                              label="Single select"
                              isSearchable={false}
                              styles={customStyles}

                              classNamePrefix="react-select"
                              formControlProps={{
                                fullWidth: true,
                              }}
                            /> */}
                            </div>
                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-flex ">
                              <div>
                                <span className="labelspan me-2">Country</span>
                              </div>
                              <input
                                type="text"
                                id="Country"
                                className="edit_inputs_align"
                                placeholder="Enter Country*"
                                name="Country Name"
                                onChange={(e) => onChangeProduct(e)}
                              />
                            </div>
                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-sm-flex ">
                              <div className='mt-2'>
                                {" "}
                                <span className="labelspan me-2">Product Image</span>
                              </div>
                              {/* <input type="text" id="productName" className='edit_inputs_align me-2' placeholder='Wallet Address*' name="wallet address"
                                onChange={(e) => onChange(e)}
                              /> */}
                              {/* <input
                                className='btn bluebtn'
                                type="file"
                                name="file"
                                accept="image/*"
                                onChange={selectFileChangeProduct} /> */}

                              <div className="addplan_mdl_img_inp_dtls mt-2">
                                <span>Select File*</span>

                              </div>
                              <button className="admin_mdl_red_btn admn_img_upld_btn mt-2">
                                Upload
                                <input
                                  className="addplan_mdl_img_inp addpln_hidden_dtl"
                                  type="file"
                                  name="file"
                                  accept="image/*"
                                  onChange={selectFileChangeProduct}
                                />
                              </button>
                            </div>
                          </div>

                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <div className="d-sm-flex">
                              <div className="me-2">
                                {" "}
                                <img
                                  src={
                                    preview_file__Product
                                      ? preview_file__Product
                                      : dummy
                                  }
                                  style={{ width: 117 }}
                                />
                              </div>
                              <p style={{ fontWeight: "500" }}>
                                Image Dimension <br /> (150 X 150)
                              </p>
                            </div>
                          </div>
                          <div
                            className="mt-3"
                            item
                            xxl={12}
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <Select
                              className='update_plan_top_slct'
                              onChange={(e) => onplanchangeProduct(e)}
                              options={Plans}
                              label="Single select"
                              isSearchable={false}
                              styles={customStyles}
                              classNamePrefix="react-select"
                              formControlProps={{
                                fullWidth: true,
                              }}
                            />
                          </div>
                        </div>
                        <div className="text-right">
                          {" "}
                          <button
                            className="admin_mdl_red_btn mt-4"
                            onClick={() => {
                              AddProductAcc();
                            }}
                          >
                            Confirm
                          </button>
                        </div>
                      </div>
                </Modal.Body>

            </Modal>

        </div>
  )
}

export default AddProductModal